import {Localizer} from "../../../infrastructure/localization/localizer";
import React, {useState} from "react";
import useScreenResolution from "../../../core/hooks/useScreenResolution";
import useDashboardKompetencer from "./useDashboardKompetencer";
import {SimpleBarChart} from "../dashboardCharts/simpleBarChart";
import classNames from "classnames";
import {Loading} from "../../../core/components/loading/loading";
import {EmblaIllustration} from "../../../core/components/emblaIcon/emblaIllustration";
import MultiLevelPieChart from "../dashboardCharts/multiLevelPieChart";
import DashboardCardSettings from "../dashboardCardSettings";
import {DashboardCardSettingsOption} from "../models/DashboardCardSettingsOption";

type DashboardKompetencerProps = {}
const DashboardKompetencer = ({}: DashboardKompetencerProps) => {
    const [showLabelsKompetencer, setShowLabelsKompetencer] = useState<boolean>(false);
    const {isMobile} = useScreenResolution();
    const {
        kompetenceBarChart,
        kompetenceProgressIsLoading,
        kompetencePieChart,
        kompetenceAktivitetIsLoading,
        kompetenceProgressTotalAmount,
        kompetenceAktivitetTotalAmount
    } = useDashboardKompetencer();

    const noProgressResults = kompetenceProgressTotalAmount <= 0 && !kompetenceProgressIsLoading;
    const noAktivitetResults = kompetenceAktivitetTotalAmount <= 0 && !kompetenceAktivitetIsLoading;

    const settingsOption: DashboardCardSettingsOption = {
        checkedValue: showLabelsKompetencer,
        setCheckedValue: setShowLabelsKompetencer,
        label: Localizer.dashboard_showLabelValues()
    };

    return <div className="card">
        <div className="card-header">
            <h4 className="card-title">{Localizer.global_kompetencer()}</h4>
            <DashboardCardSettings id={"settings-kompetencer-icon-id"}
                                   options={[settingsOption]}/>
        </div>
        {kompetenceBarChart &&
            <div className={classNames("card-body")}>
                <div className="flex-container-row wrap flex-space-between">
                    <div className={classNames("align-content-center", !isMobile && "border dashboard-card-border-radius graph-w-49")}>
                        <div className={classNames(!isMobile && "margin-m")}>
                            <h4>{Localizer.global_godkendteKompetencer()}</h4>
                            <p className={"subtle"}>{Localizer.dashboard_kompetenceProcentBeskrivelse()}</p>
                        </div>
                        <Loading isLoading={kompetenceProgressIsLoading} text={Localizer.global_kompetencer()}
                                 hideContentOnPreload={false} spinnerClasses={"margin-m"}>
                            {noProgressResults
                                ?
                                <div className={"flex-container-column align-items-center justify-content-center padding-m"}>
                                    <EmblaIllustration illustrationName={"failure-mark"} additionalClasses={"subtle"}/>
                                    <h4 className={"subtle"}> {Localizer.global_NoResultsFromFilter()} </h4>
                                </div>
                                :
                                <SimpleBarChart dataset={kompetenceBarChart}
                                                totalAmount={kompetenceProgressTotalAmount}
                                                hideLegends
                                                xLabel={Localizer.global_godkendteKompetencer()}
                                                yLabel={Localizer.global_uddannelseslaeger()}
                                />
                            }
                        </Loading>
                    </div>
                    <div className={classNames(!isMobile && "border dashboard-card-border-radius fill-card ")}>
                        <div className={classNames(!isMobile && "margin-m")}>
                            <h4>{Localizer.dashboard_kompetenceAktivitet()}</h4>
                            <p className={"subtle"}>{Localizer.dashboard_kompetenceAktivitetBeskrivelse()}</p>
                        </div>
                        <Loading isLoading={kompetenceAktivitetIsLoading}
                                 text={Localizer.dashboard_kompetenceAktivitet()}
                                 hideContentOnPreload={false} spinnerClasses={"margin-m"}>
                            {noAktivitetResults
                                ?
                                <div className={"flex-container-column align-items-center justify-content-center padding-m"}>
                                    <EmblaIllustration illustrationName={"failure-mark"} additionalClasses={"subtle"}/>
                                    <h4 className={"subtle"}> {Localizer.global_NoResultsFromFilter()} </h4>
                                </div>
                                :
                                <div className={"flex-row-center"}>
                                    <MultiLevelPieChart
                                        datasets={kompetencePieChart}
                                        showLabels={showLabelsKompetencer}
                                        totalAmount={kompetenceAktivitetTotalAmount}
                                        showLegendLabels={false}
                                        showCenterLabel
                                        overrideInnerRadius={0}
                                    />
                                </div>
                            }
                        </Loading>
                    </div>
                </div>
            </div>
        }
    </div>
}
export default DashboardKompetencer;
